export default "__VITE_ASSET__BClQqSJu__"